// L'app sur l'écran d'accueil.
//
// SELFCNTRL n'a pas d'app native : le tableau de bord EST l'app, et il sert
// surtout sur un téléphone, à des heures où on ne va pas chercher un onglet
// Safari. Ce module rend le site installable et fournit ce qu'il faut à
// <InstallApp /> pour proposer le raccourci au bon moment.
//
//   · Android / Chrome : le navigateur émet `beforeinstallprompt` ; on le
//     retient et on le rejoue au clic du bouton — c'est l'installation en un
//     geste.
//   · iOS / Safari : aucun événement, aucune API. Il faut guider la main :
//     Partager → « Sur l'écran d'accueil ». Le composant affiche les étapes.
//   · Déjà installée (fenêtre autonome) : rien à proposer.
//
// Le service worker n'est enregistré qu'en production : en développement il
// ferait écran au rechargement à chaud et servirait des fichiers périmés.

let deferred = null
const listeners = new Set()

export function registerPwa () {
  if (typeof window === 'undefined') return
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => { /* pas bloquant */ })
    })
  }
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault()
    deferred = e
    listeners.forEach(fn => fn())
  })
  window.addEventListener('appinstalled', () => {
    deferred = null
    try { localStorage.setItem('sc_pwa_installed', '1') } catch {}
    listeners.forEach(fn => fn())
  })
}

/** La fenêtre est-elle celle de l'app installée ? */
export function isStandalone () {
  if (typeof window === 'undefined') return false
  return window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
}

/** iPhone / iPad (y compris l'iPad qui se présente en Mac). */
export function isIOS () {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /iPhone|iPad|iPod/.test(ua) || (ua.includes('Mac') && navigator.maxTouchPoints > 1)
}

/** Chrome a proposé l'installation : on peut la déclencher au clic. */
export function canPromptInstall () { return !!deferred }

/** Rejoue l'invite native. Renvoie true si l'utilisateur a accepté. */
export async function promptInstall () {
  if (!deferred) return false
  const ev = deferred
  deferred = null
  ev.prompt()
  const choice = await ev.userChoice.catch(() => null)
  listeners.forEach(fn => fn())
  return choice?.outcome === 'accepted'
}

/** S'abonner aux changements (invite disponible, app installée). */
export function onPwaChange (fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
